var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 12.556 10.8 17 18 7","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Check;

Check.default = Check;
